/**
 * Formata segundos em texto legível em português.
 * Replica o comportamento de @chatwoot/utils formatTime, mas em pt-BR.
 *
 * Exemplos:
 *   45       → "45 s"
 *   90       → "1 Min 30 s"
 *   3700     → "1 Hr 1 Min"
 *   90000    → "1 Dia 1 Hr"
 */
export const formatTimePtBR = timeInSeconds => {
  if (!timeInSeconds && timeInSeconds !== 0) return '--';

  const secs = Math.floor(timeInSeconds);

  if (secs < 60) {
    return `${secs} s`;
  }

  if (secs < 3600) {
    const minutes = Math.floor(secs / 60);
    const seconds = secs % 60;
    return `${minutes} Min${seconds > 0 ? ` ${seconds} s` : ''}`;
  }

  if (secs < 86400) {
    const hours = Math.floor(secs / 3600);
    const minutes = secs % 3600 < 60 || hours === 24 ? 0 : Math.floor((secs % 3600) / 60);
    return `${hours} Hr${minutes > 0 ? ` ${minutes} Min` : ''}`;
  }

  const days = Math.floor(secs / 86400);
  const hours = secs % 86400 < 3600 || days >= 364 ? 0 : Math.floor((secs % 86400) / 3600);
  return `${days} Dia${days > 1 ? 's' : ''}${hours > 0 ? ` ${hours} Hr` : ''}`;
};
